export function getFileType(url) {
  try {
    const u = new URL(url)
    const ext = u.pathname.split(".").pop()
    return ext === "/" ? undefined : ext.toLowerCase()
  } catch {
    return ""
  }
}
